import { render, staticRenderFns } from "./RoutePage.vue?vue&type=template&id=44fe5e29"
import script from "./RoutePage.vue?vue&type=script&lang=js"
export * from "./RoutePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports